import { Component, OnInit, AfterViewInit, inject, viewChild, effect, computed, signal } from '@angular/core';
import { MatSort, MatSortHeader } from '@angular/material/sort';
import { MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';

import { environment } from '../../../environments/environment';


import { MedicRegistru } from '../../shared/models/cautare.model';
import { CautareService } from '../../shared/services/cautare.service';
import { RegistreService } from '../../shared/services/registre.service';
import { MatFormField, MatLabel, MatInput } from '@angular/material/input';
import { MatList, MatListItem } from '@angular/material/list';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { MedicStatusPipe } from '../../shared/pipes/status.pipe';
import { UiStore } from '../../shared/state/ui.store';
import { CautareStore } from '../../shared/state/cautare.store';
import { MedicNavigare } from '../../shared/services/medic-navigare.service';

@Component({
    selector: 'app-rezultat-cmj',
    templateUrl: './rezultat-cmj.component.html',
    styleUrls: ['./rezultat-cmj.component.scss'],
    imports: [MatFormField, MatLabel, MatInput, MatList, MatListItem, MatIconButton, MatIcon, MatButton, MatTable, MatSort, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatSortHeader, MatCellDef, MatCell, MatMenuTrigger, MatMenu, MatMenuItem, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MedicStatusPipe]
})
export class RezultatCmjComponent implements OnInit, AfterViewInit {
    private readonly medicNavigare = inject(MedicNavigare);
    private readonly uiStore = inject(UiStore);
    private cautareMedic = inject(CautareService);
    private readonly cautareStore = inject(CautareStore);
    regServ = inject(RegistreService);

    prod = environment.production;
    taxe = environment.taxeCmj;

    protected readonly currentUser = this.uiStore.user;

    displayedColumns = [
        'status_icon',
        'status',
        'nume',
        'prenume',
        'nume_anterior',
        'cuim',
        'cnp',
        'modificare',
        'documente',
        // 'certificat',
        // 'avizare',
        'actiuni',
    ];

    dataSource = new MatTableDataSource<MedicRegistru>();

    protected readonly selectedRowIndex = signal<string | number>(-1);
    // paginarea vine din raspunsul cautarii (links next/prev de forma ...?page=N)
    private readonly lista = this.cautareStore.listaCmj;
    protected readonly total = computed(() => this.lista()?.total ?? NaN);
    protected readonly pagini = computed(() => this.lista()?.pages ?? NaN);
    protected readonly nextPage = computed(() => this.lista()?.next ?? '');
    protected readonly prevPage = computed(() => this.lista()?.prev ?? '');
    protected readonly currentPage = computed(() => {
      const lista = this.lista();
      // fara rezultate nu se afiseaza nimic (NaN nu trece de nicio comparatie)
      if (lista == null) {
        return NaN;
      }
      const prevPg = lista.prev.match(/=\s*(.*)$/);
      const nextPg = lista.next.match(/=\s*(.*)$/);
      return Number(nextPg?.[1]) === 2 ? 1 : Number(prevPg?.[1]) + 1;
    });
    private readonly incarcaTabel = effect(() => {
      const lista = this.lista();
      if (lista != null) {
        this.dataSource.data = lista.results;
      }
    });

    readonly sort = viewChild(MatSort);

    ngOnInit() {
        if (this.taxe.includes(this.currentUser()?.judet_id ?? 0)) {
            this.displayedColumns.push('taxe');
        }
    }

    ngAfterViewInit() {
        this.dataSource.sort = this.sort();
    }

    doFilter(filterValue: string) {
        this.dataSource.filter = filterValue.trim().toLocaleLowerCase();
    }

    medicSelect(endpoint: string, medicId: string) {
        this.medicNavigare.deschide(medicId, endpoint);
    }

    clickRow(row: MedicRegistru) {
        this.selectedRowIndex.set(row.id);
    }

    getNewPage(searchVal: string, searchType: string) {
        this.cautareMedic.cautaMedic(searchVal, searchType);
    }

    getColor(statusId: number) {
        if ([1, 2, 3].includes(statusId)) {
            return 'primary';
        }

        return 'warn';
    }
}
